import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown, IContact } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { Tag } from "primereact/tag";

const schema = yup.object({
    statusId: yup.number().required("Status is required").min(1, "Status is required"),
    sourceId: yup.number().required("Source is required").min(1, "Source is required"),
    userId: yup.number().when('sourceId', {
        is: 3,
        then: schema => schema.required("Internal User is required").min(1, "Internal User is required"),
        otherwise: schema => schema.nullable(),
    }),
    partnerId: yup.number().when('sourceId', {
        is: 4,
        then: schema => schema.required("Partner is required").min(1, "Partner is required"),
        otherwise: schema => schema.nullable(),
    }),
    pocId: yup.number().when('sourceId', {
        is: 4,
        then: schema => schema.required("POC is required").min(1, "POC is required"),
        otherwise: schema => schema.nullable(),
    }),
    assignedTo: yup.number().nullable(),
});

interface Iprops {
    contacts: IContact[],
    open: boolean,
    hideDialog: () => void,
    reloadData: () => void,
    toast: any,
}

export const GenLead = (props: Iprops) => {
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [users, setUsers] = useState<IDropdown[]>();
    const [partners, setPartners] = useState<IDropdown[]>();
    const [poc, setPoc] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: { statusId: 5 },
        shouldFocusError: false,
    });

    const sourceId = watch("sourceId");
    const partnerId = watch("partnerId");

    useEffect(() => {
        loadSources();
        loadPartners();
        loadUsers();
        loadStatus();
    }, []);

    useEffect(() => {
        if (partnerId) loadPoc(partnerId);
    }, [partnerId]);

    const loadPartners = async () => {
        const response = await Fetch("partner/dropdown", "GET", null, null, null);
        if (response) {
            setPartners(await response.json());
        }
    }

    const loadPoc = async (partnerId: number) => {
        const response = await Fetch(`partnerpoc/dropdown/${partnerId}`, "GET", null, null, null);
        if (response) {
            setPoc(await response.json());
        }
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            setSources(await response.json());
        }
    }

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            setUsers(await response.json());
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            setStatus(await response.json());
        }
    }

    // const saveToDB = async (body: ILead) => {
    //     setSubmitting(true);

    //     body.contactIds = props.contacts.map(c => c.id ?? 0);

    //     const response = await Fetch(`lead`, "POST", body, null, props.toast);
    //     if (response) {
    //         onHide();
    //         props.toast.current.show({ severity: 'success', detail: "Lead Generated Successfully!", life: 3000 });
    //     }
    //     setSubmitting(false);
    // }

    const saveToDB = async (body: ILead) => {
        setSubmitting(true);

        // Prepare contact IDs
        body.contactIds = props.contacts.map(c => c.id ?? 0);

        try {
            const response = await Fetch(`lead`, "POST", body, null, props.toast);
            if (response) {
                const data = await response.json(); // <-- get message from backend
                onHide();
                props.reloadData();
                props.toast.current.show({
                    severity: 'success',
                    detail: data.message,  // <-- show backend message
                    life: 5000
                });
            }
        } catch (error: any) {
            console.error(error);
            props.toast.current.show({
                severity: 'error',
                detail: error?.message || "Something went wrong!",
                life: 5000
            });
        } finally {
            setSubmitting(false);
        }
    };

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        saveToDB(data);
    }


    return (
        <Dialog visible={props.open} style={{ width: '600px' }} header="Generate Lead" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* <div className="flex flex-wrap gap-2 mb-3 ml-3">
                    {props.contacts.map((cont, index) => {
                        return <div key={index} className="flex items-center">
                            <Tag className="mr-2 py-2 px-3" severity="warning" icon="pi pi-user" value={cont.name}></Tag>
                        </div>
                    })}
                </div> */}
                <JVDropdown column={1} required label="Source" control={control} options={sources} optionLabel="name" optionValue="id" name="sourceId" placeholder="Select Source" error={errors.sourceId?.message} />
                {sourceId === 3 && <JVDropdown column={1} required label="Internal User" control={control} options={users} optionLabel="name" optionValue="id" name="userId" placeholder="Select Internal User" error={errors.userId?.message} />}
                {sourceId === 4 && <JVDropdown column={1} required label="Partner" control={control} options={partners} optionLabel="name" optionValue="id" name="partnerId" placeholder="Select Partner" error={errors.partnerId?.message} />}
                {sourceId === 4 && <JVDropdown column={1} required label="POC" control={control} options={poc} optionLabel="name" optionValue="id" name="pocId" placeholder="Select POC" error={errors.pocId?.message} />}
                <JVDropdown column={1} label="Assign To" control={control} options={users} optionLabel="name" optionValue="id" name="assignedTo" placeholder="Select" error={errors.assignedTo?.message} />
                <JVDropdown column={1} required label="Status" control={control} options={status} optionLabel="name" optionValue="id" name="statusId" placeholder="Select Status" error={errors.statusId?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}